<app-card-wrapper [title]="'Error oplossen'">
  <p class="lead">
    Gebruik deze pagina om de error oplosser voor deze applicatie te starten. Hiermee zal lokale
    bestanden veilig verwijderd worden en u worden uitgelogd. Dit proces duurt een paar seconden en
    toont de stappen zodat u weet wat er gebeurt.
  </p>

  <div>
    <ol class="steps" aria-live="polite">
      <li *ngFor="let step of steps" [class]="step.status">
        <div class="icon">
          <span *ngIf="step.status === 'pending'" class="dot" aria-hidden="true"></span>
          <span *ngIf="step.status === 'in-progress'" class="spinner" aria-hidden="true"></span>
          <span *ngIf="step.status === 'done'" class="done" aria-hidden="true">✓</span>
        </div>
        <div class="meta">
          <div class="label">{{ step.label }}</div>
          <div class="status-text">
            <span *ngIf="step.status === 'pending'">Wachtend…</span>
            <span *ngIf="step.status === 'in-progress'">Bezig…</span>
            <span *ngIf="step.status === 'done'">Klaar</span>
          </div>
        </div>
      </li>
    </ol>

    <div class="actions">
      <button class="btn btn-primary" (click)="startReset()" [disabled]="running">
        Oplosser starten
      </button>
    </div>

    <div class="footer">
      <div *ngIf="running" class="info">
        Bezig met verwijderen… <span class="small-spinner" aria-hidden="true"></span>
      </div>
      <div *ngIf="completed" class="success">
        De lokale bestanden zijn verwijderd. U wordt afgemeld....
      </div>
    </div>
  </div>
</app-card-wrapper>
